import { useCallback, useState } from "react";
import useWeb3 from "../useWeb3";
import { getGemsTokenContract } from "../../utils/contractHelpers";
// import { useWeb3React } from "@web3-react/core";
import Environment from "../../utils/Environment";
import Web3 from "web3";

const AllowanceGems = () => {
  // const [balance, setBalance] = useState(null)
  //   const { account } = useWeb3React();
  const web3 = useWeb3();
  const contractAddress = Environment.GemsSubscription;
  const tokenAddress1 = Environment.gems;

  const allowanceGems = useCallback(
    async (account, tokenAddress, decimals) => {
      // console.log(tokenAddress,account,'noor');
      try {
        const contract = getGemsTokenContract(tokenAddress, web3);

        const buy = await contract.methods
          .allowance(account,contractAddress)
          .call();

          const allow = parseInt(buy.toString()) / 10 ** decimals;

        return allow;
      } catch (error) {
        throw error;
      }
    },
    [web3]
  );
  return { allowanceGems: allowanceGems };
};
export default AllowanceGems;
